<template>
  <button class="flex items-center gap-2 hover:bg-trader-blue justify-center rounded pointer  text-trader-text  text-center hover:text-trader-highlight active:bg-trader-darkest-gray"
          :class="[
            props.selected ? 'bg-trader-blue text-white' : 'bg-trader-gray',
            props.iconPosition === 'top' ? 'flex-col p-'+props.padding : 'flex-row px-'+padding
          ]"
          @click="props.click">
    <i class="text-center" v-if="(props.iconPosition == 'top' || props.iconPosition == 'left') && props.icon !== ''" :class="props.icon"></i>
    <span v-if="props.text !== ''" class="whitespace-nowrap">{{props.text}}</span>
    <slot></slot>
  </button>
</template>

<script setup lang="ts">

import { defineProps } from 'vue';


const props = defineProps({
  //default: () => {},
  click: {
    type: Function,
    default: () => {},
  },
  text: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  iconPosition: {
    type: String,
    default: 'top',
  },
  type: {
    type: String,
    default: 'default',
  },
  selected: {
    type: Boolean,
    default: false,
  },
  padding : {
    type: String,
    default: '2',
  },
});
</script>
